/** @format */

import { fromJS, Map } from 'immutable';

const INITIAL_STATE = fromJS({
  form: {
    userId: '',
    validUntil: '',
    organizationFriendlyId: '',
    rights: 'read'
  },
  loadingUsers: false,
  isShowing: false,
  isCreating: false,
  created: false,
  type: 'user',
  error: Map()
});

export default function shareFolderReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SHOW_SHARE_FOLDER_MODAL': {
      return INITIAL_STATE.set('isShowing', true)
        .set('isCreating', false)
        .set('type', action.payload.type);
    }
    case 'HIDE_SHARE_FOLDER_MODAL': {
      return state.set('isShowing', false);
    }
    case 'SHARE_FOLDER_FORM_CHANGE': {
      return state.setIn(['form', action.payload.name], action.payload.value);
    }
    case 'LOAD_ORGANIZATION_USERS_STARTED': {
      return state.set('loadingUsers', true);
    }
    case 'LOAD_ORGANIZATION_USERS_DONE': {
      return state.set('loadingUsers', false);
    }
    case 'LOAD_ORGANIZATION_USERS_FAILED': {
      return state.set('loadingUsers', false);
    }
    case 'FOLDER_SHARE_START': {
      return state.set('isCreating', true).set('error', Map());
    }
    case 'FOLDER_SHARE_DONE': {
      return state.set('created', true);
    }
    case 'FOLDER_SHARE_FAILED': {
      const error = action.payload.msg;
      return state.set('isCreating', false).set('error', fromJS(error));
    }
    default: {
      return state;
    }
  }
}
